import { connect } from 'react-redux';
import { IState } from '../../../../../../store/types';
import { getAudioById } from '../../../../../../store/models/selectors';
import { CaptionsCompare } from '../components/CaptionsCompare';
import { CaptionsCompareEvents } from './events';
import { ICaptionsCompareEvents, ICaptionsCompareFields, ICaptionsCompareOwnProps } from '../types';

const mapStateToProps = (
	state: IState,
	{ audioId }: ICaptionsCompareOwnProps
): ICaptionsCompareFields => {
	const audio = audioId != null ? getAudioById(state, audioId) : undefined;
	return {
		confProvider: audio?.transcriptionProvider ?? null,
	};
};

const mapDispatchToProps = (
	dispatch: any,
	{ audioId }: ICaptionsCompareOwnProps
): ICaptionsCompareEvents => ({
	onProviderChange: (provider, captions) =>
		dispatch(CaptionsCompareEvents.onProviderChange(audioId || 0, provider, captions)),
});

export const CaptionsCompareHOC = connect(
	mapStateToProps,
	mapDispatchToProps
)(CaptionsCompare);

CaptionsCompareHOC.displayName = 'CaptionsCompareHOC';
